// extracted by mini-css-extract-plugin
export var closeButton = "_lo-2";
export var closeButtonIcon = "_lo-3";
export var lightboxContent = "_lo-1";
export var lightboxOverlay = "_lo-0";